import React from 'react'
import ContactForm from './ContactForm'
import ContactAddress from './ContactAddress'
import { NavLink } from 'react-router-dom';
const FooterCopyright = () => {
  return (
    <div className="footer-bottom">
<div id="copyright" class="clr" role="contentinfo">
                <p >Designed and Developed by <a href="https://www.mss.com/" target="_blank">MSS</a> &copy; © Little Sanctum Montessori. All Right Reserved. | <a href="/Privacy-Policy" target="_blank" rel="noopener noreferrer">
  Privacy-Policy
</a></p>
						</div></div>
  )
}

export default FooterCopyright
